import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchHealthHistories() {
  return apiFetch("/api/v1/health/histories");
}

export function createHealthHistory(payload) {
  return apiFetch("/api/v1/health/histories", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateHealthHistory(id, payload) {
  return apiFetch(`/api/v1/health/histories/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteHealthHistory(id) {
  return apiFetch(`/api/v1/health/histories/${id}`, { method: "DELETE" });
}

export function fetchHealthVisits(historyId) {
  return apiFetch(`/api/v1/health/histories/${historyId}/visits`);
}

export function createHealthVisit(historyId, payload) {
  return apiFetch(`/api/v1/health/histories/${historyId}/visits`, {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateHealthVisit(historyId, visitId, payload) {
  return apiFetch(`/api/v1/health/histories/${historyId}/visits/${visitId}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteHealthVisit(historyId, visitId) {
  return apiFetch(`/api/v1/health/histories/${historyId}/visits/${visitId}`, {
    method: "DELETE",
  });
}

export function uploadHealthVisitFiles(historyId, visitId, files) {
  return apiFetch(`/api/v1/health/histories/${historyId}/visits/${visitId}/files`, {
    method: "POST",
    body: stringifySnake({ files }),
  });
}

export function deleteHealthVisitFile(historyId, visitId, resourceId) {
  return apiFetch(
    `/api/v1/health/histories/${historyId}/visits/${visitId}/files/${resourceId}`,
    { method: "DELETE" }
  );
}
